/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Environment } from '../models/Environment';

export class OverrideEnvironmentRequest {
  'environment'?: Environment;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "environment",
      "baseName": "environment",
      "type": "Environment",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return OverrideEnvironmentRequest.attributeTypeMap;
  }

  public constructor() {
  }
}



